"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (state = {
    averageSession: 0,
    blockClicks: [],
    screenViews: [],
}, action) => {
    if (action.experienceReport) {
        return action.experienceReport;
    }
    return state;
};
exports.getAverageSession = (state) => state.averageSession;
exports.getBlockClicks = (state) => state.blockClicks;
exports.getScreenViews = (state) => state.screenViews;
